import { render } from "./Sizes.vue?vue&type=template&id=966e72b0&scoped=true"
import script from "./Sizes.vue?vue&type=script&lang=js"
export * from "./Sizes.vue?vue&type=script&lang=js"

import "./Sizes.vue?vue&type=style&index=0&id=966e72b0&scoped=true&lang=css"

import exportComponent from "D:\\xampp7\\htdocs\\24x7pos\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-966e72b0"]])

export default __exports__